import { render, staticRenderFns } from "./StoreFulfillment.vue?vue&type=template&id=48d77afe&"
import script from "./StoreFulfillment.vue?vue&type=script&lang=js&"
export * from "./StoreFulfillment.vue?vue&type=script&lang=js&"
import style0 from "./StoreFulfillment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports